import type { W_JobMaterial_FindTable_VM_Single } from 'ab-api/web/jobMaterial/findTable';

import { CSVFormatter, CSVValueFormat } from '@acceligentllc/shared/utils/csv';

export const toCSVData = (materials: W_JobMaterial_FindTable_VM_Single[]) => {
	return csvFormatter.format(materials);
};

const csvFormatter = CSVFormatter.create<W_JobMaterial_FindTable_VM_Single>([
	{ header: 'Group 1', value: (row) => row.materialGroups[0] },
	{ header: 'Group 2', value: (row) => row.materialGroups[1] },
	{ header: 'Group 3', value: (row) => row.materialGroups[2] },
	{ header: 'Tags', value: (row) => row.tags.join(', ') },
	{ header: 'Item Number', value: (row) => row.itemNumber },
	{ header: 'Vendor', value: (row) => row.vendor },
	{ header: 'Name', value: (row) => row.displayName },
	{ header: 'Description', value: (row) => row.description },
	{ header: 'Unit', value: (row) => row.unit },
	{
		header: 'Base Cost ($)',
		value: (row) => row.currentRate.baseCost,
		format: CSVValueFormat.NUMBER(4, 2),
	},
	{
		header: 'Shipping Markup',
		value: (row) => row.currentRate.shippingMarkup ?? row.currentRate.jobShippingMarkup,
		format: CSVValueFormat.PERCENT(2),
	},
	{
		header: 'Sales Markup',
		value: (row) => row.currentRate.salesMarkup ?? row.currentRate.jobSalesMarkup,
		format: CSVValueFormat.PERCENT(2),
	},
	{
		header: 'Tax',
		value: (row) => row.currentRate.tax ?? row.currentRate.jobTax,
		format: CSVValueFormat.PERCENT(2),
	},
	{
		header: 'Total Cost ($)',
		value: (row) => row.currentRate.totalCost,
		format: CSVValueFormat.NUMBER(2, 2),
	},
]);
